import React, { useState, useCallback, useMemo, useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import {
  SetSliderValueMinMax,
  SetUrlPrefix,
  SetImgPrefix,
  SetIsExpanded,
  SetSliderValue,
  SetIsSearching,
  SetFiltersWithoutFilter,
  SetActiveFilters,
  SetAsyncData,
  SetListingBanner,
  SetPrevProducts,
  SetProducts,
  SetResultsCount,
  SetFilters,
  SetMasterCategories,
  SetPages,
  SetPage,
  SetSuggestedWords,
  SetFiltersWithoutCategories,
  SetFiltersWithoutPrice,
} from "../../state/actions/index"
import "./FilterAccordion.css"
import { Accordion, Card } from "react-bootstrap"
import { Slider } from "@material-ui/core"
import { withStyles } from "@material-ui/core/styles"
import Utils from "../../utils/Utils"
import axios from "axios"
import PerfectScrollbar from "react-perfect-scrollbar"

import { useNavigate } from "react-router-dom"

const FilterAccordion = (props) => {
  //const navigate = useNavigate();
  const [isExpanded, setIsExpanded] = useState({})
  const [filterWord, setFilterWord] = useState("")
  const [hoverValue, setHoverValue] = useState(0)
  const sort = useSelector((state) => state.sort)
  const placeholders = useSelector((state) => state.config.placeholders)
  const products = useSelector((state) => state.products)
  const isMobile = useSelector((state) => state.isMobile)
  const subIsExpanded = useSelector((state) => state.isExpanded)
  const accentColor = useSelector((state) => state.config.accentColor)
  const priceFormat = useSelector((state) => state.config.priceGroup.format)
  const card = useSelector((state) => state.config.card)
  const defaultCategories = useSelector((state) => state.defaultCategories)
  const sliderValue = useSelector((state) => state.sliderValue)
  const sliderValueMinMax = useSelector((state) => state.sliderValueMinMax)
  const activeFilters = useSelector((state) => state.activeFilters)
  const config = useSelector((state) => state.config)
  const filters = useSelector((state) => state.filters)
  const searchWord = useSelector((state) => state.searchWord)
  const filtersName = useSelector((state) => state.config.filters)
  const seoSettings = useSelector((state) => state.config.seoSettings)
  const defaultMasterCategories = useSelector(
    (state) => state.defaultMasterCategories
  )
  const { subCategory, setSubCategory } = props
  const dispatch = useDispatch()
  const [level, setLevel] = useState(1)

  const [subCategoryLvl2, setSubCategoryLvl2] = useState(null)
  const placeholderObject = useCallback(() => {
    var valueToReturn = {}
    valueToReturn[placeholders.wholeCategory] = { undefined: [] }
    return valueToReturn
  }, [placeholders])

  const categoryKey = useMemo(() => {
    var valueToReturn = ""
    Object.keys(filtersName).forEach((filter) => {
      if (filtersName[filter].isCategory) valueToReturn = filter
    })
    return valueToReturn
  }, [filtersName])

  const queryOptions = useSelector((state) => state.config.queryOptions)
  var rows = useMemo(
    () => (isMobile ? queryOptions.rows.mobile : queryOptions.rows.desktop),
    [isMobile, queryOptions]
  )
  const valuesToDisplay = useCallback(
    (values) =>
      values.filter(
        (item) =>
          item !== "" && item.toLowerCase().includes(filterWord.toLowerCase())
      ),
    [filterWord]
  )
  var selectedStyle = useMemo(() => {
    return { backgroundColor: accentColor }
  }, [accentColor])
  var ratingArray = useMemo(
    () =>
      filtersName[props.value.title] &&
      filtersName[props.value.title].type === "rating"
        ? Utils.createArrayOfIntegerFromOneToIndex(
            props.value.values.max ? parseInt(props.value.values.max) : 0
          )
        : [],
    [props, filtersName]
  )
  const MuiSlider = withStyles({
    root: {
      color: accentColor,
    },
    thumb: {
      border: `2px solid ${accentColor}`,
    },
    active: {
      border: `solid 1px ${accentColor}`,
    },
  })(Slider)

  var hoverValueToUse = useMemo(() => {
    if (
      filtersName[props.value.title]
        ? filtersName[props.value.title].type !== "rating"
        : true
    )
      return 0
    var indexToCheck = -1
    activeFilters.forEach((item, index) => {
      if (item.key === props.value.title) {
        indexToCheck = index
        return false
      }
    })
    if (hoverValue > 0) return hoverValue
    else if (indexToCheck === -1) return 0
    else return activeFilters[indexToCheck].value[0]
  }, [activeFilters, filtersName, props, hoverValue])

  const onGenericFilterClick = useCallback(
    (parent, value, isMultiChoice = false) => {
      var tempActiveFilters = activeFilters
      var itemToAdd = { key: parent, value: value }
      var index = Utils.checkValueAndKeyInArray(
        tempActiveFilters,
        itemToAdd,
        filtersName
      )
      if (index === -1) tempActiveFilters.push(itemToAdd)
      else tempActiveFilters.splice(index, 1)
      if (
        index !== -1 &&
        (filtersName[parent].type === "slider" ||
          filtersName[parent].type === "rating")
      )
        tempActiveFilters.push(itemToAdd)
      dispatch(SetIsSearching(true))
      dispatch(SetAsyncData([]))
      var priceGroup = {}
      priceGroup.id =
        window.AS_ADVANCED_CONFIG && window.AS_ADVANCED_CONFIG.visitorType
          ? window.AS_ADVANCED_CONFIG.visitorType
          : config.priceGroup.id
      priceGroup.currency =
        window.AS_ADVANCED_CONFIG && window.AS_ADVANCED_CONFIG.currencyCode
          ? window.AS_ADVANCED_CONFIG.currencyCode
          : config.priceGroup.currency
      var localSearchUrl = Utils.getSearchUrl(
        config.baseUrl,
        config.queryOptions,
        priceGroup,
        config.shopId,
        config.jsonFast
      )
      axios
        .get(
          Utils.insertWordInSearchUrl(
            localSearchUrl,
            searchWord,
            tempActiveFilters,
            sort,
            1,
            filtersName,
            rows
          )
        )
        .then((res) => {
          var response = res.data
          dispatch(SetIsExpanded({}))
          dispatch(SetPrevProducts(products))
          dispatch(
            SetProducts(
              Utils.refactorUrl(
                response.data,
                response.header.imagePrefix,
                response.header.urlPrefix,
                card.img,
                card.url
              )
            )
          )
          dispatch(SetSuggestedWords(response.suggestions))
          dispatch(SetResultsCount(response.header.results_count))
          dispatch(
            SetSliderValueMinMax(
              Utils.addSliderValue(response, sliderValueMinMax)
            )
          )
          dispatch(SetSliderValue(Utils.addSliderValue(response, sliderValue)))
          if (
            isMultiChoice &&
            tempActiveFilters
              .map((activeFilter) => activeFilter.key)
              .includes(props.value.title) &&
            tempActiveFilters.length > 0
          )
            dispatch(
              SetFiltersWithoutFilter({
                response: response,
                filterType: parent,
              })
            )
          else dispatch(SetFilters(response))
          dispatch(SetActiveFilters(tempActiveFilters))
          dispatch(
            SetPages(parseInt((response.header.results_count - 1) / rows) + 1)
          )
          dispatch(SetPage(1))
          dispatch(SetListingBanner(response.banners[0]))
          dispatch(
            SetMasterCategories(
              response.stats[categoryKey]
                ? Utils.refactorMasterCategories(
                    Object.keys(response.stats[categoryKey])
                  )
                : defaultMasterCategories
            )
          )
          dispatch(SetUrlPrefix(response.header.urlPrefix))
          dispatch(SetImgPrefix(response.header.imagePrefix))
          if (config.webhook.key !== "")
            Utils.getAsyncData(config.webhook, response.data, priceGroup).then(
              (value) => dispatch(SetAsyncData(value.asyncData))
            )
          var websiteSearchBar = document.getElementById(
            "accelasearch-bar-container-container"
          )
          const event = new CustomEvent("as-search-event", {
            detail: {
              searchWord: searchWord,
              filters: tempActiveFilters,
              page: 1,
            },
          })
          websiteSearchBar.dispatchEvent(event)
        })
        .finally(() => dispatch(SetIsSearching(false)))
    },
    [
      searchWord,
      dispatch,
      activeFilters,
      filtersName,
      defaultMasterCategories,
      rows,
      sort,
      sliderValueMinMax,
      sliderValue,
      config,
      products,
      categoryKey,
      card,
      props,
    ]
  )
  const onSliderFilterChange = useCallback(
    (value) => {
      dispatch(SetSliderValue(value))
      var tempActiveFilters = activeFilters
      var itemToAdd = { key: "sellingPrice", value: value }
      var index = Utils.checkKeyInArray(tempActiveFilters, itemToAdd)
      if (index === -1) tempActiveFilters.push(itemToAdd)
      else tempActiveFilters[index] = itemToAdd
      dispatch(SetIsSearching(true))
      dispatch(SetAsyncData([]))
      var priceGroup = {}
      priceGroup.id =
        window.AS_ADVANCED_CONFIG && window.AS_ADVANCED_CONFIG.visitorType
          ? window.AS_ADVANCED_CONFIG.visitorType
          : config.priceGroup.id
      priceGroup.currency =
        window.AS_ADVANCED_CONFIG && window.AS_ADVANCED_CONFIG.currencyCode
          ? window.AS_ADVANCED_CONFIG.currencyCode
          : config.priceGroup.currency
      var localSearchUrl = Utils.getSearchUrl(
        config.baseUrl,
        config.queryOptions,
        priceGroup,
        config.shopId,
        config.jsonFast
      )
      axios
        .get(
          Utils.insertWordInSearchUrl(
            localSearchUrl,
            searchWord,
            tempActiveFilters,
            sort,
            1,
            filtersName,
            rows
          )
        )
        .then((res) => {
          var response = res.data
          var responseMinMax = [
            response.stats.sellingPrice.min,
            response.stats.sellingPrice.max,
          ]
          dispatch(SetIsExpanded({}))
          dispatch(SetPrevProducts(products))
          dispatch(
            SetProducts(
              Utils.refactorUrl(
                response.data,
                response.header.imagePrefix,
                response.header.urlPrefix,
                card.img,
                card.url
              )
            )
          )
          dispatch(SetSuggestedWords(response.suggestions))
          dispatch(SetResultsCount(response.header.results_count))
          dispatch(SetFiltersWithoutPrice(response))
          var tempActiveFilters = activeFilters
          var itemToAdd = { key: "sellingPrice", value: responseMinMax }
          var index = Utils.checkKeyInArray(tempActiveFilters, itemToAdd)
          if (index === -1) tempActiveFilters.push(itemToAdd)
          else tempActiveFilters[index] = itemToAdd
          dispatch(SetActiveFilters(tempActiveFilters))
          dispatch(
            SetPages(parseInt((response.header.results_count - 1) / rows) + 1)
          )
          dispatch(SetPage(1))
          dispatch(SetListingBanner(response.banners[0]))
          dispatch(SetSliderValue(responseMinMax))
          dispatch(
            SetMasterCategories(
              response.stats[categoryKey]
                ? Utils.refactorMasterCategories(
                    Object.keys(response.stats[categoryKey])
                  )
                : defaultMasterCategories
            )
          )
          dispatch(SetUrlPrefix(response.header.urlPrefix))
          dispatch(SetImgPrefix(response.header.imagePrefix))
          if (config.webhook.key !== "")
            Utils.getAsyncData(config.webhook, response.data, priceGroup).then(
              (value) => dispatch(SetAsyncData(value.asyncData))
            )
          var websiteSearchBar = document.getElementById(
            "accelasearch-bar-container-container"
          )
          const event = new CustomEvent("as-search-event", {
            detail: {
              searchWord: searchWord,
              filters: tempActiveFilters,
              page: 1,
            },
          })
          websiteSearchBar.dispatchEvent(event)
        })
        .finally(() => dispatch(SetIsSearching(false)))
    },
    [
      searchWord,
      dispatch,
      activeFilters,
      defaultMasterCategories,
      rows,
      sort,
      config,
      filtersName,
      products,
      categoryKey,
      card,
    ]
  )
  const onCategoryFilterClick = useCallback(
    (value, isMultiChoice = true) => {
      var tempActiveFilters = activeFilters
      var itemToAdd = { key: categoryKey, value: value }
      var index = Utils.checkValueAndKeyInArray(
        tempActiveFilters,
        itemToAdd,
        filtersName
      )
      if (index === -1) {
        if (Utils.isMiddleCategory(value))
          tempActiveFilters = Utils.removeSubFilters(tempActiveFilters, value)
        else if (value.split("/")[value.split("/").length - 1] !== "*") {
          tempActiveFilters = Utils.removeMiddleFilters(
            tempActiveFilters,
            value
          )
        }
        tempActiveFilters.push(itemToAdd)
      } else tempActiveFilters.splice(index, 1)
      dispatch(SetIsSearching(true))
      dispatch(SetAsyncData([]))
      var priceGroup = {}
      priceGroup.id =
        window.AS_ADVANCED_CONFIG && window.AS_ADVANCED_CONFIG.visitorType
          ? window.AS_ADVANCED_CONFIG.visitorType
          : config.priceGroup.id
      priceGroup.currency =
        window.AS_ADVANCED_CONFIG && window.AS_ADVANCED_CONFIG.currencyCode
          ? window.AS_ADVANCED_CONFIG.currencyCode
          : config.priceGroup.currency
      var localSearchUrl = Utils.getSearchUrl(
        config.baseUrl,
        config.queryOptions,
        priceGroup,
        config.shopId,
        config.jsonFast
      )
      axios
        .get(
          Utils.insertWordInSearchUrl(
            localSearchUrl,
            searchWord,
            tempActiveFilters,
            sort,
            1,
            filtersName,
            rows
          )
        )
        .then((res) => {
          var response = res.data
          dispatch(SetIsExpanded({}))
          dispatch(SetPrevProducts(products))
          dispatch(
            SetProducts(
              Utils.refactorUrl(
                response.data,
                response.header.imagePrefix,
                response.header.urlPrefix,
                card.img,
                card.url
              )
            )
          )
          dispatch(SetSuggestedWords(response.suggestions))
          dispatch(SetResultsCount(response.header.results_count))
          dispatch(
            SetSliderValueMinMax(
              Utils.addSliderValue(response, sliderValueMinMax)
            )
          )
          dispatch(SetSliderValue(Utils.addSliderValue(response, sliderValue)))
          if (isMultiChoice) {
            dispatch(SetFiltersWithoutCategories(response))
          } else {
            dispatch(SetFilters(response))
            // if (tempActiveFilters.length > 0 && response.stats.categories) {
            //   let category = Object.entries(response.stats.categories).filter(
            //     ([key, val]) => key === value
            //   );
            //   if (category.length > 0) {
            //     category = category.at(0);
            //     const splitted = category[0]?.split("/");
            //     const subValue = {};
            //     subValue[splitted.at(-1)] = { count: category[1] };
            //     const splittedValue = value.split("/");
            //     const newSubCategory = {
            //       key: splittedValue.at(-2) ?? splittedValue.at(-1),
            //       level: splitted.length - 1,
            //       parent: splittedValue.at(-3) ?? "",
            //       parentChildren: {},
            //       value: subValue,
            //     };
            //     setSubCategory(newSubCategory);
            //   } else {
            //     let total = 0;
            //     Object.values(response.stats.categories).map(
            //       (value) => (total += value)
            //     );
            //     const splitted = value.split("/");
            //     const subValue = {};
            //     subValue["count"] = { count: total };
            //     const newSubCategory = {
            //       key: splitted.at(-1).replace("*", ""),
            //       level: splitted.length - 1,
            //       parent: splitted.at(-2) ?? "",
            //       parentChildren: {},
            //       value: subValue,
            //     };

            //     setSubCategory(newSubCategory);
            //   }
            // } else {
            //   console.log(subCategory);
            // }
          }
          dispatch(SetActiveFilters(tempActiveFilters))
          dispatch(
            SetPages(parseInt((response.header.results_count - 1) / rows) + 1)
          )
          dispatch(SetPage(1))
          dispatch(SetListingBanner(response.banners[0]))
          dispatch(
            SetMasterCategories(
              response.stats[categoryKey]
                ? Utils.refactorMasterCategories(
                    Object.keys(response.stats[categoryKey])
                  )
                : defaultMasterCategories
            )
          )
          dispatch(SetUrlPrefix(response.header.urlPrefix))
          dispatch(SetImgPrefix(response.header.imagePrefix))
          if (config.webhook.key !== "")
            Utils.getAsyncData(config.webhook, response.data, priceGroup).then(
              (value) => dispatch(SetAsyncData(value.asyncData))
            )
          var websiteSearchBar = document.getElementById(
            "accelasearch-bar-container-container"
          )
          const event = new CustomEvent("as-search-event", {
            detail: {
              searchWord: searchWord,
              filters: tempActiveFilters,
              page: 1,
            },
          })
          websiteSearchBar.dispatchEvent(event)
        })
        .finally(() => dispatch(SetIsSearching(false)))
    },
    [
      searchWord,
      dispatch,
      activeFilters,
      filtersName,
      rows,
      defaultMasterCategories,
      sort,
      sliderValueMinMax,
      sliderValue,
      config,
      products,
      categoryKey,
      card,
    ]
  )

  const filterOnChange = useCallback(
    (evt) => {
      if (evt.keyCode === 13) evt.target.blur()
      else setFilterWord(evt.target.value)
    },
    [setFilterWord]
  )

  const getCompleteCategory = useCallback(
    (key, subKey) =>
      Utils.getCompleteCategory(
        Object.keys(props.value.values),
        [key, subKey],
        filtersName[props.value.title].level
      ),
    [props, filtersName]
  )

  const getCompleteValue = useCallback(
    (key, subKey) =>
      getCompleteCategory(key, subKey) +
      (Utils.checkLastCategory(filters, getCompleteCategory(key, subKey))
        ? ""
        : "/*"),
    [getCompleteCategory, filters]
  )

  const checkDisabled = useCallback(
    (value, level) =>
      Utils.checkDisabled(
        value,
        placeholders.wholeCategory,
        level,
        Object.keys(props.value.values)
      ),
    [placeholders, props]
  )

  const checkDisabledParent = useCallback(
    (value, level) =>
      Utils.checkDisabled(
        value,
        placeholders.wholeCategory,
        level,
        Object.keys(
          filters.filter((item) => item.title === props.value.parentTitle)[0]
            .values
        )
      ),
    [placeholders, props, filters]
  )

  var toggleExpanded = useCallback(
    (key) => {
      var objectToReturn = { ...isExpanded }
      objectToReturn[key] = !objectToReturn[key]
      setIsExpanded(objectToReturn)
    },
    [isExpanded, setIsExpanded]
  )

  var toggleSubExpanded = useCallback(
    (key) => {
      var objectToReturn = { ...subIsExpanded }
      objectToReturn[key] = !objectToReturn[key]
      dispatch(SetIsExpanded(objectToReturn))
    },
    [subIsExpanded, dispatch]
  )

  function setParentCategory(key, value, lvl, goingBack = false) {
    let parent = ""
    let parentChildren = subCategory?.parentChildren ?? []
    if (!goingBack) {
      if (lvl > 2) {
        parent = `${subCategory.parent}/${subCategory.key}`
      } else if (lvl > 1) {
        parent = subCategory?.key
      }
      subCategory?.value && parentChildren.push(subCategory.value)
      if (!!lvl) {
        setLevel(lvl + 1)
      } else {
        setLevel(1)
      }
    } else {
      parent = subCategory.parent?.split("/").at(-2)
      key = key?.split("/").at(-1)
      if (!!lvl) {
        setLevel(lvl + 1)
      } else {
        setLevel(1)
      }
    }

    // if (lvl >= level) {
    //   setLevel(lvl + 1);
    // } else if (!!lvl) {
    //   setLevel(lvl);
    // } else {
    //   setLevel(1);
    // }

    setSubCategory({
      key,
      value,
      parent: parent,
      parentChildren,
      level: !!lvl ? lvl : 1,
    })
  }

  function checkNotDouble(key) {
    if (
      (!key?.includes("*") &&
        Object.keys(subCategory?.value).includes(key + "*")) ||
      key === "count"
    ) {
      // let cat = Object.keys(subCategory?.value).find((v) => v === key + "*");
      // subCategory.value[cat].count += subCategory.value[key].count;
      return false
    }

    return true
  }
  function getSubTotal(values) {
    let count = 0
    values.map((value, index) => {
      if (!isNaN(value)) {
        count += value
      } else if (!!value.count) {
        count += value.count
        if (Object.values(value).length > 1) {
          count += getSubTotal(Object.values(value).filter((val) => isNaN(val)))
        }
      } else {
        count += getSubTotal(Object.values(value))
      }
    })
    return count
  }

  useEffect(() => {
    const tempFilters = [...activeFilters]
    const searchParams = new URLSearchParams()
    searchParams.set("query", searchWord)
    if (Array.isArray(tempFilters)) {
      tempFilters.forEach((filter) => {
        searchParams.append(filter.key, filter.value)
      })
    }
    const queryString = searchParams.toString()
    // navigate(`/${seoSettings.searchWord}/?${queryString}`)
    // window.location.pathname = `/${seoSettings.searchWord}/?${queryString}`;
    // window.history.pushState(
    //   {},
    //   "Title",
    //   `/${seoSettings.searchWord}/?${queryString}`
    // );
  }, [activeFilters, searchWord])
  function displayShowAll() {
    if (filtersName[props.value.title].type !== "checkbox-MC") {
      if (activeFilters.length > 0) {
        if (
          activeFilters.find((filter) => filter.value.includes("*")) ===
          undefined
        ) {
          const o = Object.entries(subCategory.value).filter(
            ([key, val]) =>
              !!Utils.isSelected(activeFilters, {
                key: props.value.title,
                value:
                  key === placeholders.showAll ? `${subCategory?.key}*` : key,
                level: subCategory.level,
              })
          )

          return o
        } else {
          const objToReturn = [
            [
              placeholders.showAll,
              {
                count: getSubTotal(Object.values(subCategory.value)),
              },
            ],
            ...Object.entries(subCategory.value),
          ].filter(
            ([key, val]) =>
              !!Utils.isSelected(activeFilters, {
                key: props.value.title,
                value:
                  key === placeholders.showAll ? `${subCategory?.key}*` : key,
              })
          )
          const filtered = objToReturn.filter(
            (obj) => obj[0] === placeholders.showAll
          )
          if (filtered.length > 0) {
            return filtered
          }
          return objToReturn
        }
      }
    }
    return [
      [
        placeholders.showAll,
        {
          count: getSubTotal(Object.values(subCategory.value)),
        },
      ],
      ...Object.entries(subCategory.value),
    ]
  }

  return (
    <div>
      {(() => {
        if (
          filtersName[props.value.title] &&
          filtersName[props.value.title].isCategory
        ) {
          if (filtersName[props.value.title].level === -1) {
            return (
              <Accordion
                activeKey={
                  isExpanded[props.defaultActiveKey]
                    ? props.defaultActiveKey
                    : ""
                }
              >
                <Card>
                  <Accordion.Toggle
                    eventKey={props.defaultActiveKey}
                    as={Card.Header}
                    onClick={() => toggleExpanded(props.defaultActiveKey)}
                  >
                    {filtersName[props.value.title]
                      ? filtersName[props.value.title].label
                      : props.value.title}{" "}
                    <span
                      className={
                        "icon" +
                        (isExpanded[props.defaultActiveKey] ? " expanded" : "")
                      }
                    >
                      {" "}
                    </span>
                  </Accordion.Toggle>
                  <Accordion.Collapse eventKey={props.defaultActiveKey}>
                    <Card.Body>
                      {filtersName[props.value.title].withSearch &&
                      (valuesToDisplay(Object.keys(props.value.values)).length >
                        1 ||
                        filterWord !== "") ? (
                        <div className="search-outer">
                          <div className="search icon"></div>
                          <input
                            placeholder={placeholders.filterSearchbar}
                            value={filterWord}
                            onChange={filterOnChange}
                            className={filterWord.length > 0 ? "with-text" : ""}
                          ></input>
                          {filterWord !== "" ? (
                            <div
                              className="delete-search"
                              onClick={() => setFilterWord("")}
                            ></div>
                          ) : null}
                        </div>
                      ) : null}
                      <div className="icon"></div>
                      {valuesToDisplay(Object.keys(props.value.values)).length >
                      0 ? (
                        <PerfectScrollbar>
                          {valuesToDisplay(Object.keys(props.value.values)).map(
                            (key, index) => (
                              <div
                                className={
                                  "as-filter checkbox-sc" +
                                  (Utils.isSelected(activeFilters, {
                                    key: props.value.title,
                                    value: key.split("/").at(-1),
                                  })
                                    ? " selected"
                                    : "")
                                  //   +
                                  // (checkDisabled(
                                  //   key,
                                  //   filtersName[props.value.title].level
                                  // )
                                  //   ? " disabled"
                                  //   : "")
                                }
                                key={"filter_key_" + index}
                                onClick={() =>
                                  filtersName[props.value.title].type ===
                                  "checkbox-MC"
                                    ? onCategoryFilterClick(key)
                                    : onGenericFilterClick(
                                        props.value.title,
                                        key
                                      )
                                }
                              >
                                <div className="key">
                                  {" "}
                                  <span className="icon"></span>{" "}
                                  <span className="value">
                                    {Utils.refactorCategoryLabelByLevel(
                                      key,
                                      filtersName[props.value.title]
                                        ? filtersName[props.value.title].level
                                        : -1
                                    )}
                                    <span className="counter">
                                      {props.value.values[key]}
                                    </span>
                                  </span>
                                </div>
                              </div>
                            )
                          )}
                        </PerfectScrollbar>
                      ) : (
                        <div className="no-filters">
                          {" "}
                          {placeholders.noCategory}{" "}
                        </div>
                      )}
                    </Card.Body>
                  </Accordion.Collapse>
                </Card>
              </Accordion>
            )
          } else if (filtersName[props.value.title].level === 0) {
            return (
              <Accordion
                activeKey={
                  isExpanded[props.defaultActiveKey]
                    ? props.defaultActiveKey
                    : ""
                }
              >
                <Card>
                  <Accordion.Toggle
                    eventKey={props.defaultActiveKey}
                    as={Card.Header}
                    onClick={() => toggleExpanded(props.defaultActiveKey)}
                    className={!!subCategory?.key ? "sub" : ""}
                  >
                    {!!subCategory?.key && (
                      <span
                        className="parent-category"
                        onClick={(e) => {
                          e.stopPropagation()
                          if (
                            subCategory.level > 1 &&
                            Object.keys(subCategory.parentChildren).length > 0
                          ) {
                            setParentCategory(
                              subCategory.parent,
                              subCategory.parentChildren?.pop(),
                              subCategory.level - 1,
                              true
                            )
                          } else {
                            setParentCategory(null)
                          }
                        }}
                      ></span>
                    )}
                    {!!subCategory?.key
                      ? subCategory.key
                      : filtersName[props.value.title]
                      ? filtersName[props.value.title].label
                      : props.value.title}{" "}
                    <span
                      className={
                        "icon" +
                        (isExpanded[props.defaultActiveKey] ? " expanded" : "")
                      }
                    >
                      {" "}
                    </span>
                  </Accordion.Toggle>
                  <Accordion.Collapse eventKey={props.defaultActiveKey}>
                    <Card.Body>
                      <PerfectScrollbar>
                        {!!subCategory?.key
                          ? displayShowAll()?.map(([key, value], index) => {
                              if (
                                Object.keys(value).length < 2 &&
                                (Object.keys(value).at(0) === "count" ||
                                  key === "count")
                              ) {
                                return (
                                  key !== "" &&
                                  key !== "undefined" &&
                                  checkNotDouble(key) && (
                                    <div
                                      className={
                                        "as-filter checkbox-sc" +
                                        (Utils.isSelected(activeFilters, {
                                          key: props.value.title,
                                          value:
                                            key === placeholders.showAll
                                              ? `${subCategory?.key}*`
                                              : key,
                                        })
                                          ? " selected"
                                          : "")
                                      }
                                      key={"filter_key_" + index}
                                      onClick={() => {
                                        onCategoryFilterClick(
                                          (subCategory.parent
                                            ? subCategory.parent + "/"
                                            : "") +
                                            subCategory.key +
                                            (key === placeholders.showAll
                                              ? "*"
                                              : "/" + key),
                                          filtersName[props.value.title]
                                            .type === "checkbox-MC"
                                        )
                                      }}
                                    >
                                      {
                                        <div className="key">
                                          {" "}
                                          <span className="icon"></span>{" "}
                                          <span className="value">
                                            {key
                                              ?.replace("/*", "")
                                              ?.replace("*", "")}
                                          </span>
                                          <span className="counter">
                                            {value?.count}
                                          </span>
                                        </div>
                                      }
                                    </div>
                                  )
                                )
                              } else {
                                return (
                                  <div
                                    className={"as-filter"}
                                    key={"filter_key_" + index}
                                    onClick={() =>
                                      setParentCategory(key, value, level)
                                    }
                                  >
                                    <div className="category-root">
                                      <span className="value">{key}</span>
                                      <span className={"icon"}> </span>
                                    </div>
                                  </div>
                                )
                              }
                            })
                          : Object.entries(
                              Utils.refactorCategories(
                                Object.entries(props.value.values),
                                filtersName[props.value.title].level
                              )
                            )?.map(
                              ([key, value], index) =>
                                key !== "" && (
                                  <div
                                    className={"as-filter"}
                                    key={"filter_key_" + index}
                                    onClick={() =>
                                      setParentCategory(key, value, level)
                                    }
                                  >
                                    <div className="category-root">
                                      <span className="value">{key}</span>
                                      <span className={"icon"}> </span>
                                    </div>
                                  </div>
                                )
                            )}
                      </PerfectScrollbar>
                    </Card.Body>
                  </Accordion.Collapse>
                </Card>
              </Accordion>
            )
          }
        } else
          switch (
            filtersName[props.value.title]
              ? filtersName[props.value.title].type
              : null
          ) {
            case "slider":
              return (
                <Accordion
                  activeKey={
                    isExpanded[props.defaultActiveKey]
                      ? props.defaultActiveKey
                      : ""
                  }
                >
                  <Card>
                    <Accordion.Toggle
                      eventKey={props.defaultActiveKey}
                      as={Card.Header}
                      onClick={() => toggleExpanded(props.defaultActiveKey)}
                    >
                      {filtersName[props.value.title]
                        ? filtersName[props.value.title].label
                        : props.value.title}{" "}
                      <span
                        className={
                          "icon" +
                          (isExpanded[props.defaultActiveKey]
                            ? " expanded"
                            : "")
                        }
                      >
                        {" "}
                      </span>
                    </Accordion.Toggle>
                    <Accordion.Collapse eventKey={props.defaultActiveKey}>
                      <Card.Body>
                        {/* add [props.value.title] and modify setSliderValue e setSliderValueMinMax with slider title*/}
                        <div className="slider">
                          <div className="price-container">
                            <div className="price-da-container">
                              <div className="label">
                                {" "}
                                {placeholders.fromSlider}
                              </div>
                              <div style={{ position: "relative" }}>
                                <input
                                  max={sliderValueMinMax[1]}
                                  min={sliderValueMinMax[0]}
                                  value={Utils.setNumberFormat(
                                    sliderValue[0],
                                    priceFormat.decimals,
                                    priceFormat.dec_divider,
                                    priceFormat.migl_divider
                                  )}
                                  disabled
                                  className={!!sliderValue ? "has-text" : ""}
                                  onChange={(evt) =>
                                    onSliderFilterChange([
                                      parseFloat(evt.target.value),
                                      sliderValue[0],
                                    ])
                                  }
                                ></input>
                                <div className="currency">€</div>
                              </div>
                            </div>
                            <div className="price-a-container">
                              <div className="label">
                                {" "}
                                {placeholders.toSlider}{" "}
                              </div>
                              <div style={{ position: "relative" }}>
                                <input
                                  max={sliderValueMinMax[1]}
                                  min={sliderValueMinMax[0]}
                                  value={Utils.setNumberFormat(
                                    sliderValue[1],
                                    priceFormat.decimals,
                                    priceFormat.dec_divider,
                                    priceFormat.migl_divider
                                  )}
                                  disabled
                                  className={!!sliderValue ? "has-text" : ""}
                                  onChange={(evt) =>
                                    onSliderFilterChange([
                                      parseFloat(evt.target.value),
                                      sliderValue[1],
                                    ])
                                  }
                                ></input>
                                <div className="currency">€</div>
                              </div>
                            </div>
                          </div>
                          <MuiSlider
                            value={sliderValue}
                            onChange={(event, newValue) =>
                              dispatch(SetSliderValue(newValue))
                            }
                            onChangeCommitted={(event, newValue) =>
                              onSliderFilterChange(newValue)
                            }
                            min={sliderValueMinMax[0]}
                            max={sliderValueMinMax[1]}
                          />
                        </div>
                      </Card.Body>
                    </Accordion.Collapse>
                  </Card>
                </Accordion>
              )
            case "button-SC":
            case "button-MC":
              return (
                <Accordion
                  activeKey={
                    isExpanded[props.defaultActiveKey]
                      ? props.defaultActiveKey
                      : ""
                  }
                >
                  <Card>
                    <Accordion.Toggle
                      eventKey={props.defaultActiveKey}
                      as={Card.Header}
                      onClick={() => toggleExpanded(props.defaultActiveKey)}
                    >
                      {filtersName[props.value.title]
                        ? filtersName[props.value.title].label
                        : props.value.title}{" "}
                      <span
                        className={
                          "icon" +
                          (isExpanded[props.defaultActiveKey]
                            ? " expanded"
                            : "")
                        }
                      >
                        {" "}
                      </span>
                    </Accordion.Toggle>
                    <Accordion.Collapse eventKey={props.defaultActiveKey}>
                      <Card.Body>
                        {filtersName[props.value.title].withSearch &&
                        (valuesToDisplay(Object.keys(props.value.values))
                          .length > 1 ||
                          filterWord !== "") ? (
                          <div className="search-outer">
                            <div className="search icon"></div>
                            <input
                              placeholder={placeholders.filterSearchbar}
                              value={filterWord}
                              onChange={filterOnChange}
                              className={
                                filterWord.length > 0 ? "with-text" : ""
                              }
                            ></input>
                            {filterWord !== "" ? (
                              <div
                                className="delete-search"
                                onClick={() => setFilterWord("")}
                              ></div>
                            ) : null}
                          </div>
                        ) : null}
                        {valuesToDisplay(Object.keys(props.value.values))
                          .length > 0 ? (
                          <PerfectScrollbar className="button">
                            {(filtersName[props.value.title].filterSorting ===
                            "results"
                              ? valuesToDisplay(Object.keys(props.value.values))
                              : valuesToDisplay(
                                  Object.keys(props.value.values)
                                ).sort((a, b) =>
                                  filtersName[props.value.title]
                                    .filterSorting === "ASC"
                                    ? a.localeCompare(b)
                                    : b.localeCompare(a)
                                )
                            ).map((key, index) => (
                              // <div className={"filter button-sc"+(Utils.isSelected(activeFilters,{key:props.value.title,value:key})?" selected":"")} key={'filter_key_'+index} onClick={()=>
                              <div
                                className={
                                  "as-filter button-sc" +
                                  (Utils.isSelected(activeFilters, {
                                    key: props.value.title,
                                    value: key,
                                  })
                                    ? " selected"
                                    : "")
                                }
                                key={"filter_key_" + index}
                                style={
                                  Utils.isSelected(activeFilters, {
                                    key: props.value.title,
                                    value: key,
                                  })
                                    ? selectedStyle
                                    : null
                                }
                                onClick={() =>
                                  filtersName[props.value.title] &&
                                  filtersName[props.value.title].type ===
                                    "button-MC"
                                    ? onGenericFilterClick(
                                        props.value.title,
                                        key,
                                        true
                                      )
                                    : onGenericFilterClick(
                                        props.value.title,
                                        key
                                      )
                                }
                              >
                                <div className="key">
                                  {" "}
                                  <span className="value">{key}</span>
                                </div>
                              </div>
                            ))}
                          </PerfectScrollbar>
                        ) : (
                          <div className="no-filters">
                            {" "}
                            {placeholders.noCategory}{" "}
                          </div>
                        )}
                      </Card.Body>
                    </Accordion.Collapse>
                  </Card>
                </Accordion>
              )
            case "checkbox-SC":
            case "checkbox-MC":
              return (
                <Accordion
                  activeKey={
                    isExpanded[props.defaultActiveKey]
                      ? props.defaultActiveKey
                      : ""
                  }
                >
                  <Card>
                    <Accordion.Toggle
                      eventKey={props.defaultActiveKey}
                      as={Card.Header}
                      onClick={() => toggleExpanded(props.defaultActiveKey)}
                    >
                      {filtersName[props.value.title]
                        ? filtersName[props.value.title].label
                        : props.value.title}{" "}
                      <span
                        className={
                          "icon" +
                          (isExpanded[props.defaultActiveKey]
                            ? " expanded"
                            : "")
                        }
                      >
                        {" "}
                      </span>
                    </Accordion.Toggle>
                    <Accordion.Collapse eventKey={props.defaultActiveKey}>
                      <Card.Body>
                        {filtersName[props.value.title].withSearch &&
                        (valuesToDisplay(Object.keys(props.value.values))
                          .length > 1 ||
                          filterWord !== "") ? (
                          <div className="search-outer">
                            <div className="search icon"></div>
                            <input
                              placeholder={placeholders.filterSearchbar}
                              value={filterWord}
                              onChange={filterOnChange}
                              className={
                                filterWord.length > 0 ? "with-text" : ""
                              }
                            ></input>
                            {filterWord !== "" ? (
                              <div
                                className="delete-search"
                                onClick={() => setFilterWord("")}
                              ></div>
                            ) : null}
                          </div>
                        ) : null}
                        {valuesToDisplay(Object.keys(props.value.values))
                          .length > 0 ? (
                          <PerfectScrollbar>
                            {filtersName[props.value.title].filterSorting ===
                            "results"
                              ? valuesToDisplay(
                                  Object.keys(props.value.values)
                                ).map((key, index) => (
                                  <div
                                    className={
                                      "as-filter checkbox-sc" +
                                      (Utils.isSelected(activeFilters, {
                                        key: props.value.title,
                                        value: key,
                                      })
                                        ? " selected"
                                        : "")
                                    }
                                    key={"filter_key_" + index}
                                    onClick={() =>
                                      filtersName[props.value.title] &&
                                      filtersName[props.value.title].type ===
                                        "checkbox-MC"
                                        ? onGenericFilterClick(
                                            props.value.title,
                                            key,
                                            true
                                          )
                                        : onGenericFilterClick(
                                            props.value.title,
                                            key
                                          )
                                    }
                                  >
                                    <div className="key">
                                      {" "}
                                      <span className="icon"></span>{" "}
                                      <span className="value">{key}</span>
                                    </div>
                                  </div>
                                ))
                              : valuesToDisplay(Object.keys(props.value.values))
                                  .sort((a, b) =>
                                    filtersName[props.value.title]
                                      .filterSorting === "ASC"
                                      ? a.localeCompare(b)
                                      : b.localeCompare(a)
                                  )
                                  .map((key, index) => (
                                    <div
                                      className={
                                        "as-filter checkbox-sc" +
                                        (Utils.isSelected(activeFilters, {
                                          key: props.value.title,
                                          value: key,
                                        })
                                          ? " selected"
                                          : "")
                                      }
                                      key={"filter_key_" + index}
                                      onClick={() =>
                                        filtersName[props.value.title] &&
                                        filtersName[props.value.title].type ===
                                          "checkbox-MC"
                                          ? onGenericFilterClick(
                                              props.value.title,
                                              key,
                                              true
                                            )
                                          : onGenericFilterClick(
                                              props.value.title,
                                              key
                                            )
                                      }
                                    >
                                      <div className="key">
                                        {" "}
                                        <span className="icon"></span>{" "}
                                        <span className="value">{key}</span>
                                      </div>
                                    </div>
                                  ))}
                          </PerfectScrollbar>
                        ) : (
                          <div className="no-filters">
                            {" "}
                            {placeholders.noCategory}{" "}
                          </div>
                        )}
                      </Card.Body>
                    </Accordion.Collapse>
                  </Card>
                </Accordion>
              )
            case "alph-SC":
            case "alph-MC":
              return (
                <Accordion
                  activeKey={
                    isExpanded[props.defaultActiveKey]
                      ? props.defaultActiveKey
                      : ""
                  }
                >
                  <Card>
                    <Accordion.Toggle
                      eventKey={props.defaultActiveKey}
                      as={Card.Header}
                      onClick={() => toggleExpanded(props.defaultActiveKey)}
                    >
                      {filtersName[props.value.title]
                        ? filtersName[props.value.title].label
                        : props.value.title}{" "}
                      <span
                        className={
                          "icon" +
                          (isExpanded[props.defaultActiveKey]
                            ? " expanded"
                            : "")
                        }
                      >
                        {" "}
                      </span>
                    </Accordion.Toggle>
                    <Accordion.Collapse eventKey={props.defaultActiveKey}>
                      <Card.Body>
                        {filtersName[props.value.title].withSearch &&
                        (valuesToDisplay(Object.keys(props.value.values))
                          .length > 1 ||
                          filterWord !== "") ? (
                          <div className="search-outer">
                            <div className="search icon"></div>
                            <input
                              placeholder={placeholders.filterSearchbar}
                              value={filterWord}
                              onChange={filterOnChange}
                              className={
                                filterWord.length > 0 ? "with-text" : ""
                              }
                            ></input>
                            {filterWord !== "" ? (
                              <div
                                className="delete-search"
                                onClick={() => setFilterWord("")}
                              ></div>
                            ) : null}
                          </div>
                        ) : null}
                        {valuesToDisplay(Object.keys(props.value.values))
                          .length > 0 ? (
                          <PerfectScrollbar>
                            {Utils.alphabeticalRefactor(
                              valuesToDisplay(
                                Object.keys(props.value.values)
                              ).sort((a, b) =>
                                filtersName[props.value.title].filterSorting ===
                                "ASC"
                                  ? a.localeCompare(b)
                                  : b.localeCompare(a)
                              )
                            ).map((object) => (
                              <div key={"filter_key_" + object.group}>
                                <div className="letter"> {object.group} </div>
                                {object.children.map((key, index) => (
                                  <div
                                    className={
                                      "as-filter checkbox-sc" +
                                      (Utils.isSelected(activeFilters, {
                                        key: props.value.title,
                                        value: key,
                                      })
                                        ? " selected"
                                        : "")
                                    }
                                    key={"filter_key_" + index}
                                    onClick={() =>
                                      filtersName[props.value.title] &&
                                      filtersName[props.value.title].type ===
                                        "alph-MC"
                                        ? onGenericFilterClick(
                                            props.value.title,
                                            key,
                                            true
                                          )
                                        : onGenericFilterClick(
                                            props.value.title,
                                            key
                                          )
                                    }
                                  >
                                    <div className="key">
                                      {" "}
                                      <span className="icon"></span>{" "}
                                      <span className="value">{key}</span>
                                    </div>
                                  </div>
                                ))}
                              </div>
                            ))}
                          </PerfectScrollbar>
                        ) : (
                          <div className="no-filters">
                            {" "}
                            {placeholders.noCategory}{" "}
                          </div>
                        )}
                      </Card.Body>
                    </Accordion.Collapse>
                  </Card>
                </Accordion>
              )
            case "rating":
              return (
                <Accordion
                  activeKey={
                    isExpanded[props.defaultActiveKey]
                      ? props.defaultActiveKey
                      : ""
                  }
                >
                  <Card>
                    <Accordion.Toggle
                      eventKey={props.defaultActiveKey}
                      as={Card.Header}
                      onClick={() => toggleExpanded(props.defaultActiveKey)}
                    >
                      {filtersName[props.value.title]
                        ? filtersName[props.value.title].label
                        : props.value.title}{" "}
                      <span
                        className={
                          "icon" +
                          (isExpanded[props.defaultActiveKey]
                            ? " expanded"
                            : "")
                        }
                      >
                        {" "}
                      </span>
                    </Accordion.Toggle>
                    <Accordion.Collapse eventKey={props.defaultActiveKey}>
                      <Card.Body>
                        <PerfectScrollbar>
                          <div className="as-filter rating">
                            <div className="key">
                              <div className="values-container">
                                {ratingArray.map((item) => (
                                  <span
                                    className={
                                      "value" +
                                      (item <= hoverValueToUse
                                        ? " selected"
                                        : "")
                                    }
                                    onMouseLeave={() => setHoverValue(0)}
                                    onMouseEnter={() => setHoverValue(item)}
                                    onClick={() => {
                                      onGenericFilterClick(props.value.title, [
                                        item,
                                        props.value.values.max,
                                      ])
                                    }}
                                    key={"value_" + item}
                                  >
                                    {" "}
                                  </span>
                                ))}
                                {hoverValueToUse > 0 ? (
                                  <div className="disclaimer">
                                    {" "}
                                    Products with at least {
                                      hoverValueToUse
                                    }{" "}
                                    stars
                                  </div>
                                ) : null}
                              </div>
                            </div>
                          </div>
                        </PerfectScrollbar>
                      </Card.Body>
                    </Accordion.Collapse>
                  </Card>
                </Accordion>
              )
            default:
              return null
          }
      })()}
    </div>
  )
}

export default FilterAccordion
